import React, { useEffect } from 'react';
import { MessageSquare } from 'react-feather';
import { useAuth } from '../contexts/AuthContext';
import { UserTypeDetector } from '../../../src/utils/UserTypeDetector';

export interface ConversationStarterProps {
  onRoleCollected: (role: string) => void;
  onConversationReady: () => void;
  initialMessage?: string;
  showRoleCollection?: boolean;
}

const ConversationStarter: React.FC<ConversationStarterProps> = ({
  onRoleCollected,
  onConversationReady,
  initialMessage,
  showRoleCollection: _showRoleCollection = true
}) => {
  void _showRoleCollection; // Prop available for future role selection UI
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    // Auto-detect user type and immediately mark conversation as ready
    if (isAuthenticated && user) {
      // Use centralized detection logic for consistency
      const userType = UserTypeDetector.isInternalUser(user) ? 'internal' : 'other';
      console.log('🔐 Auto-detected user type:', userType, 'for', user.name);
      onRoleCollected(userType);
    } else {
      // Non-authenticated users default to empty role
      onRoleCollected('');
    }
    onConversationReady();
  }, [isAuthenticated, user, onRoleCollected, onConversationReady]);

  // Show simplified welcome message
  return (
    <div className="conversation-starter">
      <div className="welcome-message-container mb-6">
        <div className="message assistant">
          <div className="message-avatar">
            <MessageSquare size={20} />
          </div>
          <div className="message-content">
            <div className="message-text">
              <div dangerouslySetInnerHTML={{
                __html: initialMessage || (
                  UserTypeDetector.isInternalUser(user)
                    ? `Hello! I'm Eddy, your Edelweiss Assistant. I see you're a team member - I'm here to help you find the documentation and answers you need about the Edelweiss platform.<br><br>What can I help you with today?`
                    : `Hello! I'm Eddy, your Edelweiss Assistant. I can help you with questions about the Edelweiss platform, including orders, digital review copies, collections, event grids, and more.<br><br>To provide the most relevant answers, please let me know your role in the book industry (e.g., bookseller, librarian, publisher) along with your question. What can I help you with today?`
                )
              }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationStarter;